import { useCurrentWorkspace } from './useCurrentWorkspace'

export const useIsAPFreemium = () => {
  const workspace = useCurrentWorkspace()

  return workspace?.is_virtual_marketer && workspace?.is_ap_freemium
}
